var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.segments),function(segment){
var _obj;
return _c('span',{key:segment.id,class:( _obj = {}, _obj[_vm.highlightClass] = segment.type === 'highlight', _obj ),style:(_vm.getStyles(segment))},[_vm._v("\n        "+_vm._s(segment.text)+"\n    ")])}))}
var staticRenderFns = []

export { render, staticRenderFns }